import { EcpLocatorRequestUrls } from './ecp-locator.request-urls';
import { restClient } from '../rest-client';
import { EcpLocatorData, TInternetShopResponse, TEcpLocatorResponse } from './ecp-locator.models';

export const ecpLocatorApi = {
  getStores(data: EcpLocatorData) {
    return restClient.post<TEcpLocatorResponse>(EcpLocatorRequestUrls.ecpLocator, data);
  },
  getInternetShops() {
    return restClient.get<TInternetShopResponse>(EcpLocatorRequestUrls.internetShops);
  },
};
